import { Component, HostListener, Input } from '@angular/core';
import { SocialFeedService } from '../../services/social-feed.service';

/**
 * A post's photos: one big picture, or a tidy grid for 2-4. Clicking any
 * photo opens it full-size in a viewer with previous/next (arrow keys work
 * too) and Escape / click-outside to close.
 */
@Component({
  selector: 'app-social-image-gallery',
  templateUrl: './social-image-gallery.component.html',
  styleUrls: ['./social-image-gallery.component.scss'],
  standalone: false,
})
export class SocialImageGalleryComponent {
  @Input() images: string[] = [];
  /** Fallback for a post that only carries the single `image` field. */
  @Input() image: string | null = null;

  viewerIndex: number | null = null;

  constructor(private socialFeedService: SocialFeedService) {}

  get urls(): string[] {
    const paths = this.images?.length ? this.images : this.image ? [this.image] : [];
    return paths.map((path) => this.socialFeedService.resolveImageUrl(path));
  }

  openViewer(index: number): void {
    this.viewerIndex = index;
  }

  closeViewer(): void {
    this.viewerIndex = null;
  }

  step(delta: number, event?: Event): void {
    event?.stopPropagation();
    const count = this.urls.length;
    if (this.viewerIndex === null || count < 2) {
      return;
    }
    this.viewerIndex = (this.viewerIndex + delta + count) % count;
  }

  @HostListener('document:keydown', ['$event'])
  onKey(event: KeyboardEvent): void {
    if (this.viewerIndex === null) {
      return;
    }
    if (event.key === 'Escape') {
      this.closeViewer();
    } else if (event.key === 'ArrowRight') {
      this.step(1);
    } else if (event.key === 'ArrowLeft') {
      this.step(-1);
    }
  }
}
